export const REFRESH_INTERVAL = 5 // in minutes



// WEBPACK FOOTER //
// ./src/constants/autoRefresh.js